module.exports = __webpack_public_path__ + "img/675.b9aef891.png";